import qs from 'qs';

import actionTypes from 'Redux/constants';

import http from 'utlis/http';

export const getDesignReviewCountsAction = platform => async dispatch => {
  try {
    const queryParams = platform ? qs.stringify({ platform }) : '';

    const config = {
      method: 'get',
      url: `${process.env.REACT_APP_BASE_URL}/api/v1/project/team/design-reviews/count/?${queryParams}`,
    };

    const response = await http(config);

    dispatch({
      type: actionTypes.GET_DESIGN_REVIEW_COUNTS,
      payload: response.data,
    });

    return response.data;
  }
  catch (error) {
    const defaultCounts = {
      reviews_this_month: 0,
      reviews_in_progress: 0,
      reviews_completed: 0,
      reviews_total: 0,
      customer_name: 'Unknown',
    };

    dispatch({
      type: actionTypes.GET_DESIGN_REVIEW_COUNTS,
      payload: defaultCounts,
    });

    return defaultCounts;
  }
};

export const setDesignReviewHistory = data => dispatch => {
  dispatch({
    type: actionTypes.GET_DESIGN_REVIEW_HISTORY,
    payload: data,
  });
};

export const getDesignReviewHistoryAction = (
  days,
  page,
  pageSize,
  platform,
  search = null,
  reviewStatus = null
) => async dispatch => {
  try {
    const params = {
      days,
      page,
      page_size: pageSize,
      platform,
    };

    // Add search parameter if provided and not empty
    if (search && search.trim()) {
      params.search = search.trim();
    }

    // Add reviewStatus parameter if provided
    if (reviewStatus !== null && reviewStatus !== undefined) {
      params.status = reviewStatus;
    }

    const queryParams = qs.stringify(params);

    const config = {
      method: 'get',
      url: `${process.env.REACT_APP_BASE_URL}/api/v1/project/team/design-reviews/history/?${queryParams}`,
    };

    const response = await http(config);

    dispatch(setDesignReviewHistory(response.data));

    return response.data;
  }
  catch (error) {
    const defaultHistory = {
      count: 0,
      next: null,
      previous: null,
      results: [],
    };

    dispatch(setDesignReviewHistory(defaultHistory));

    return defaultHistory;
  }
};

export const setReviewCount = data => dispatch => {
  dispatch(
    {
      type: actionTypes.SET_REVIEW_COUNT,
      payload: data,
    }
  );
};

export const getReviewDataAction = () => async dispatch => {
  // Set loading to true before API call
  dispatch({
    type: actionTypes.SET_REVIEW_COUNT_LOADING,
    payload: true,
  });

  try {
    const config = {
      method: 'get',
      url: `${process.env.REACT_APP_BASE_URL}/api/v1/user/reviewer/design_review_count/`,
    };

    const response = await http(config);

    dispatch({
      type: actionTypes.SET_REVIEW_COUNT,
      payload: response.data,
    });

    // Set loading to false after successful API call
    dispatch({
      type: actionTypes.SET_REVIEW_COUNT_LOADING,
      payload: false,
    });

    return response.data;
  }
  catch (error) {
    const defaultReviewData = {
      current_week_deeper_insights_used: 0,
      current_week_reviews_done: 0,
      free_credits_received: false,
      nps_survey_shown: false,
      nps_survey_submitted: false,
      reviews_done: 0,
      reviews_remaining: 0,
      total_multiscreen_used: 0,
      upgrade_to_pro_popup_shown: false,
    };

    dispatch({
      type: actionTypes.SET_REVIEW_COUNT,
      payload: defaultReviewData,
    });

    // Set loading to false after error
    dispatch({
      type: actionTypes.SET_REVIEW_COUNT_LOADING,
      payload: false,
    });

    return defaultReviewData;
  }
};
